// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"styles_carouselContainer__M21b5","carouselItem":"styles_carouselItem__60oVm","container":"styles_container__YgwAZ"};